import { render, staticRenderFns } from "./PaymentDataForm.vue?vue&type=template&id=14210e09&"
import script from "./PaymentDataForm.vue?vue&type=script&lang=js&"
export * from "./PaymentDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports